import { Chat } from 'services/hub';
import ChatApp from './ChatApp';



const ChatPage = () => {
  return (

    <ChatApp />
  );
};

export default ChatPage